import { render, staticRenderFns } from "./HeadersDataTableSettings.vue?vue&type=template&id=c100a34c&scoped=true"
import script from "./HeadersDataTableSettings.vue?vue&type=script&lang=js"
export * from "./HeadersDataTableSettings.vue?vue&type=script&lang=js"
import style0 from "./HeadersDataTableSettings.vue?vue&type=style&index=0&id=c100a34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c100a34c",
  null
  
)

export default component.exports